import { useTranslation } from "react-i18next";
import { TOTAL_STEPS, WIZARD_STEPS } from "./wizard-config";

// Persistent top tab bar. Completed tabs are filled, the current tab is
// highlighted, future tabs are dimmed. Counter normalizes to "X of 10".
const OnboardingTabBar = ({ current, onTabClick }) => {
  const { t } = useTranslation("auth");

  return (
    <nav className="onboarding-tabbar">
      <ul>
        {WIZARD_STEPS.map((step) => {
          const state =
            step.id === current
              ? "active"
              : step.id < current
              ? "completed"
              : "future";
          // Only allow jumping back to already-completed steps.
          const clickable = step.id < current && !step.scaffold;
          const handleActivate = clickable
            ? () => onTabClick(step.id)
            : undefined;
          return (
            <li
              key={step.id}
              className={`tab ${state}`}
              data-clickable={clickable}
              role={clickable ? "button" : undefined}
              tabIndex={clickable ? 0 : undefined}
              onClick={handleActivate}
              onKeyDown={
                clickable
                  ? (e) => {
                      if (e.key === "Enter" || e.key === " ") handleActivate();
                    }
                  : undefined
              }
            >
              <span className="tab-index">{step.id}.</span>
              <span className="tab-label">
                {t(`onboardingWizard.tabs.${step.key}`)}
              </span>
            </li>
          );
        })}
      </ul>
      <span className="step-counter">
        {t("onboardingWizard.stepCounter", { current, total: TOTAL_STEPS })}
      </span>
    </nav>
  );
};

export default OnboardingTabBar;
